import React, { Component } from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { AccessType } from "@quintype/components";
import { connect } from "react-redux";
import loadingIcon from "../../../assets/icons/loading.svg";
import { SvgHandler } from "../svg-handler/svg-handler";
import { accessCheck } from "../../../isomorphic/utils";
import "./subscription-page.m.css";

class SubscriptionTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSubscriptions: {},
      isSubscribeButtonClicked: false,
      selectedPlan: {}
    };
  }

  componentDidMount() {
    this.props.initAccessType();
  }

  async handleSubscriptionClick(e, subscriptionGroup) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ isSubscribeButtonClicked: true });
    const firstPlan = get(subscriptionGroup, ["subscription_plans", 0]);
    const selectedPlan = get(this.state, ["selectedSubscriptions", subscriptionGroup.id], firstPlan);
    this.setState({ selectedPlan });

    if (!this.props.member) {
      this.props.openLoginTemplate();
      return false;
    }

    const subscription = await this.openPaymentScreen();
    subscription && this.navigateToUserDetailsPage();
  }

  openPaymentScreen() {
    return this.props.initRazorPayPayment(this.state.selectedPlan);
  }

  navigateToUserDetailsPage() {
    this.props.navigateTo(`/user-details`);
  }

  async componentDidUpdate(prevProps) {
    if (prevProps.member !== this.props.member) {
      if (this.props.member && this.state.isSubscribeButtonClicked) {
        const subscription = await this.openPaymentScreen();
        subscription && this.navigateToUserDetailsPage();
      }
    }
  }

  getSubscriptionBlocks(subscriptionGroups) {
    return subscriptionGroups.map((subscriptionGroup, index) => (
      <div styleName="group" key={`group-${index}`}>
        <div styleName="desc-wrapper">
          <span styleName="subscription-group">{subscriptionGroup.name}</span>
          <div styleName="wrapper-content">
            <p styleName="plan-time">
              {this.getPriceBlock(subscriptionGroups, index)}
              <span styleName="month">{this.getPlanDuration(subscriptionGroups, index)}</span>
            </p>
            <p styleName="plan-desc">{subscriptionGroup.description}</p>
          </div>
          {this.getDurationBlock(subscriptionGroup)}
        </div>
      </div>
    ));
  }

  getPriceBlock(subscriptionGroups, currentGroupIndex) {
    const firstPlanPrice = get(subscriptionGroups, [currentGroupIndex, "subscription_plans", 0, "price_cents"]);
    return (
      get(
        this.state,
        ["selectedSubscriptions", subscriptionGroups[currentGroupIndex].id, "price_cents"],
        firstPlanPrice
      ) / 100
    );
  }
  getPlanDuration(subscriptionGroups, currentGroupIndex) {
    const firstPlanUnit = get(subscriptionGroups, [currentGroupIndex, "subscription_plans", 0, "duration_unit"]);
    const firstPlanDuration = get(subscriptionGroups, [currentGroupIndex, "subscription_plans", 0, "duration_length"]);
    const planUnit = get(
      this.state,
      ["selectedSubscriptions", subscriptionGroups[currentGroupIndex].id, "duration_unit"],
      firstPlanUnit
    );
    const planDuration = get(
      this.state,
      ["selectedSubscriptions", subscriptionGroups[currentGroupIndex].id, "duration_length"],
      firstPlanDuration
    );

    return (
      <span>
        <span>{planDuration}</span>
        <span>{planUnit}</span>
      </span>
    );
  }

  getDurationBlock(subscriptionGroup) {
    const plans = get(subscriptionGroup, ["subscription_plans"], []);
    const subscriptionGroupId = get(subscriptionGroup, ["id"]);
    const planList = (
      <div styleName="select-wrapper">
        <select onChange={e => this.handlePlanChange(e, subscriptionGroupId)} styleName="plan-selection">
          {plans.map((plan, index) => (
            <option key={`plan-${index}`} value={JSON.stringify(plan)}>
              {plan.title}
            </option>
          ))}
        </select>
      </div>
    );
    return (
      <div styleName="duration-wrapper">
        {planList}
        <button
          data-testid="plans-subscribe-btn"
          styleName="subs-btn"
          onClick={e => this.handleSubscriptionClick(e, subscriptionGroup)}
        >
          Subscribe
        </button>
      </div>
    );
  }

  handlePlanChange(e, subscriptionGroupId) {
    const currentPlan = JSON.parse(e.target.value);
    const currentState = Object.assign({}, this.state.selectedSubscriptions, { [subscriptionGroupId]: currentPlan });
    this.setState({ selectedSubscriptions: currentState });
  }

  render() {
    const planLayout = get(this.props, ["config", "theme-attributes", "plan-page-layout"], "");
    const planTitle = get(this.props, ["config", "theme-attributes", "plan_page_title"], "");
    const planDesc = get(this.props, ["config", "theme-attributes", "plan_page_desc"], "");
    const groups = get(this.props, ["subscriptions"], []);

    return (
      <div className="component-wrapper" styleName={`${planLayout === "list-view" ? "component-wrapper" : " "}`}>
        <div styleName="content-wrapper">
          <h1 styleName="plan-title">{planTitle}</h1>
          <p>{planDesc}</p>
        </div>
        {groups && groups.length ? (
          <div styleName={`${planLayout === "list-view" ? "list-view" : "groups-layout"}`}>
            {this.getSubscriptionBlocks(groups)}
          </div>
        ) : (
          <SvgHandler clazzName="loader" xlinkHref={loadingIcon} />
        )}
      </div>
    );
  }
}

SubscriptionTemplate.propTypes = {
  initAccessType: PropTypes.func,
  initRazorPayPayment: PropTypes.func,
  openLoginTemplate: PropTypes.func,
  getSubscriptionForUser: PropTypes.func,
  navigateTo: PropTypes.func,
  member: PropTypes.object,
  getSubscription: PropTypes.func
};

function SubscriptionBase(props) {
  const email = get(props, ["member", "email"]);
  const phone = get(props, ["member", "metadata", "phone-number"], "1234");
  const accessTypeKey = get(props, ["config", "theme-attributes", "accesstypeKey"]);
  const isStaging = get(props, ["config", "theme-attributes", "accesstypeEnvironment"]) === "staging";
  const enableAccesstype = get(props, ["config", "theme-attributes", "enableAccesstype"], false);

  return (
    <AccessType
      enableAccesstype={accessCheck(enableAccesstype)}
      isStaging={isStaging}
      accessTypeKey={accessTypeKey}
      email={email}
      phone={phone}
    >
      {({ initAccessType, initRazorPayPayment }) => (
        <SubscriptionTemplate initRazorPayPayment={initRazorPayPayment} initAccessType={initAccessType} {...props} />
      )}
    </AccessType>
  );
}

const mapStateToProps = state => ({
  config: get(state, ["qt", "config"], {}),
  subscriptions: get(state, ["subscriptions"], null),
  member: get(state, ["member"], null)
});

const mapDispatchToProps = dispatch => ({
  openLoginTemplate: () => dispatch({ type: "OPEN_LOGIN_TEMPLATE" }),
  navigateTo: url => global.app.navigateToPage(dispatch, url)
});

export const Subscription = connect(
  mapStateToProps,
  mapDispatchToProps
)(SubscriptionBase);
